/* eslint-disable */
import {createStore} from 'vuex'
import geral from './modules/geral'
import token from './modules/token'
import usuarios from './modules/usuarios'
import configDash from './modules/configDash'
// Módulos para as tabelas de cadastro
import parametros from './modules/parametros'
import sincronizacao from "./modules/sincronizacao";
import cidades from "./modules/cidades";
import servicos from "./modules/servicos";

export default createStore({
   modules: {
      geral,
      usuarios,
      token,
      cidades,
      servicos,
      configDash,
      parametros,
      sincronizacao
   }
})
